import _cloneDeep from "lodash/cloneDeep";
import _isEqual from "lodash/isEqual";
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, toHandlers as _toHandlers, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "disabled-option"
};
const _hoisted_2 = {
  key: 1
};
import { ElSelect, ElTree } from 'element-plus';
import 'element-plus/es/components/select/style/css'
import 'element-plus/es/components/tree/style/css'


import { ref, onMounted, watch } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XTreeSelect',
  props: {
    modelValue: {
      type: [Array, String, Number, Boolean, Object]
    },
    value: {
      type: [Array, String, Number, Boolean, Object]
    },
    options: {
      default: () => []
    },
    adapter: {
      type: Function,
      default: option => option
    },
    loading: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    autoExpandCheckedNode: {
      type: Boolean,
      default: false
    },
    includeHalfCheckedNode: {
      type: Boolean,
      default: true
    },
    placeholder: {},
    noDataText: {
      default: '暂无数据'
    },
    clearable: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'select'],
  setup(__props, {
    emit: __emit
  }) {
    const prop = __props;
    const emit = __emit;
    const selectOptions = ref([]);
    const treeOptions = ref([]);
    const list = ref([]);
    const treeRef = ref();
    const selectRef = ref();
    onMounted(() => {
      loadTreeOptions(prop.options);
    });
    watch(() => prop.options, val => {
      loadTreeOptions(val);
    });
    watch(() => prop.value, val => {
      if (!_isEqual(val, prop.modelValue)) {
        refreshTreeCheckState();
      }
    });
    function handleSelectChange() {
      refreshTreeCheckState();
    }
    function handleSelectVisibleChange(visible) {
      if (visible) {
        expandCheckedNode();
      }
    }
    function handleNodeClick(data) {
      if (data.disabled) {
        return;
      }
      if (!prop.multiple) {
        setSelectedOptions([data.value]);
        closeDropdown();
        emitOptionSelected([_cloneDeep(data)]);
        selectOptions.value.push(data);
      }
    }
    function handleCheckChange() {
      if (prop.multiple && treeRef.value) {
        const checked = [...treeRef.value.getCheckedKeys()];
        if (prop.includeHalfCheckedNode) {
          checked.push(...treeRef.value.getHalfCheckedKeys());
        }
        setSelectedOptions(checked);
        const nodes = treeRef.value.getCheckedNodes(false, prop.includeHalfCheckedNode);
        emitOptionSelected(nodes ? _cloneDeep(nodes) : []);
      }
    }
    function setSelectedOptions(optionsValue) {
      if (!optionsValue || optionsValue.length < 1) {
        clearSelectedOptions();
        return;
      }
      if (prop.multiple) {
        emit('update:modelValue', optionsValue);
      } else {
        emit('update:modelValue', optionsValue[0]);
      }
    }
    function clearSelectedOptions() {
      if (prop.multiple) {
        // this.$emit('update:modelValue', [])
      } else {
        // this.$emit('update:modelValue', undefined)
      }
    }
    function closeDropdown() {
      selectRef.value?.handleClose();
    }
    function loadTreeOptions(options) {
      list.value = [];
      treeOptions.value = [];
      selectOptions.value = [];
      if (!options || options.length < 1) {
        return;
      }
      const opt = adaptTreeOptions(options);
      treeOptions.value.push(...opt);
      selectOptions.value.push(...list.value);
      refreshTreeCheckState();
    }
    function adaptTreeOptions(options) {
      if (!options) {
        return [];
      }
      const result = [];
      for (const option of options) {
        const adapted = prop.adapter(option);
        if (adapted.children) {
          adapted.children = adaptTreeOptions(adapted.children);
        }
        list.value.push(adapted);
        result.push(adapted);
      }
      return result;
    }
    function refreshTreeCheckState() {
      if (prop.multiple && treeOptions.value && treeOptions.value.length > 0) {
        const selected = prop.modelValue;
        if (selected && selected.length > 0) {
          setTreeCheckedValues(selected);
        } else {
          clearTreeCheckState();
        }
      }
    }
    function expandCheckedNode() {
      if (!prop.autoExpandCheckedNode) {
        return;
      }
      const checkedNodes = treeRef.value?.getCheckedNodes(false, true);
      if (checkedNodes && checkedNodes.length > 0) {
        for (const node of checkedNodes) {
          expandParentNode(treeRef.value?.getNode(node));
        }
      }
    }
    function expandParentNode(node) {
      if (!node) {
        return;
      }
      const parent = node.parent;
      if (!parent || parent.expanded) {
        return;
      }
      parent.expanded = true;
      expandParentNode(parent);
    }
    function setTreeCheckedValues(values) {
      treeRef.value?.setCheckedKeys(values);
    }
    function clearTreeCheckState() {
      treeRef.value?.setCheckedKeys([]);
    }
    function emitOptionSelected(options) {
      emit('select', options);
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_unref(ElSelect), _mergeProps({
        style: {
          "width": "100%"
        },
        ref_key: "selectRef",
        ref: selectRef,
        "model-value": _ctx.modelValue,
        multiple: _ctx.multiple,
        loading: _ctx.loading,
        placeholder: _ctx.placeholder,
        clearable: _ctx.clearable,
        "collapse-tags": _ctx.collapseTags
      }, _toHandlers(_ctx.$attrs), {
        onChange: handleSelectChange,
        onVisibleChange: handleSelectVisibleChange
      }), {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          key: "XTreeSelect-hidden-option",
          label: "XTreeSelect-hidden-option",
          value: "XTreeSelect-hidden-option",
          disabled: "",
          style: {
            "height": "auto",
            "background": "white",
            "padding": "0"
          }
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElTree), {
            ref_key: "treeRef",
            ref: treeRef,
            data: _unref(treeOptions),
            "node-key": "value",
            "empty-text": _ctx.noDataText,
            "show-checkbox": _ctx.multiple,
            "expand-on-click-node": _ctx.multiple,
            "check-strictly": _ctx.multiple && _ctx.flat,
            style: {
              "margin": "6px"
            },
            onNodeClick: handleNodeClick,
            onCheck: handleCheckChange
          }, {
            default: _withCtx(({
              node,
              data
            }) => [_ctx.$slots.default ? _renderSlot(_ctx.$slots, "default", {
              key: 0,
              node: node,
              option: data
            }) : (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [node.disabled ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(node.label), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(node.label), 1))], 64))]),
            _: 3
          }, 8, ["data", "empty-text", "show-checkbox", "expand-on-click-node", "check-strictly"])]),
          _: 3
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectOptions), option => {
          return _withDirectives((_openBlock(), _createBlock(_component_el_option, {
            key: option.value,
            value: option.value,
            label: option.label
          }, null, 8, ["value", "label"])), [[_vShow, false]]);
        }), 128))]),
        _: 3
      }, 16, ["model-value", "multiple", "loading", "placeholder", "clearable", "collapse-tags"])]);
    };
  }
});